// HKDSE 2017 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2017Samples_complete.js and hkdse2017Samples_complete_part2.js

import { hkdse2017Samples_complete } from './hkdse2017Samples_complete.js';
import { hkdse2017Samples_complete_part2 } from './hkdse2017Samples_complete_part2.js';

export const hkdse2017Samples_complete_combined = {
  ...hkdse2017Samples_complete,
  ...hkdse2017Samples_complete_part2
};

// Export individual parts for backward compatibility
export { hkdse2017Samples_complete, hkdse2017Samples_complete_part2 }; 